export const PlanDetailAttributes = {
	HBB_DOWN_SPEED: 'HBB_DOWN_SPEED',
	HBB_UP_SPEED: 'HBB_UP_SPEED',
	// 'HBB_MAIL_INC',
	INCLUDED_MINUTES: 'INCLUDED_MINUTES',
	// INT_CALL_DISCOUNT_SIZE: 'INT_CALL_DISCOUNT_SIZE',
};
export const BoosterPlanDetailAttributes = {
	downloadSpeed: 'downloadSpeed',
	uploadSpeed: 'uploadSpeed',
	callsToMobile: 'callsToMobile',
};

export const fbbPlansTypes = {
	fbb: 'fbb',
	fbbPro: 'fbbPro',
	booster: 'booster',
};
export const commitmentTimesFBB = [12, 24, 36];
export const commitmentTimesFiberPro = [12, 24, 36];
export const boosterTabType = 'booster';
export const fbbTabType = 'fbb';
export const fbbProTabType = 'fbbPro';
export const fbbPlanUpperLimitSpeed = 50;
export const fbbPlanLowerLimitSpeed = 20;
export const Offer_PRICE = 'Offer';
export const Display_PRICE = 'Display';
export const additionalServiceTableColumnList = ['', 'serviceType', 'monthlyFee', 'instaFee'];
export const planDetailTableColumnList = [
	'',
	'planColumn',
	'downSpeedColumn',
	'uploadSpeedColumn',
	'callMobileColumn',
	'priceColumn',
];
export const addOnServiceAttribute = 'FBB_PRO_FEATURES';
export const attributes = [
	'HBB_DOWN_SPEED',
	'HBB_UP_SPEED',
	'HBB_MAIL_INC',
	'INCLUDED_MINUTES',
	'INT_CALL_DISCOUNT_SIZE',
];

export const commitmentTimes = [12, 24, 36];
